import React, { useEffect, useState } from "react";
import {
  getCurrentDate,
  getCurrentMonthFirstDate,
  getFinancialYearStart,
} from "../../../../Utilitie";
import axios from "axios";
import NoDataFound from "../../../../Extra/NoDataFound";
import Loading from "../../../../Extra/Loading";
import DayWisePosition from "./DayWisePosition";
import MonthWisePosition from "./MonthWisePosition";

const CrewDemandPosition = () => {
  const [startDate, setStartDate] = useState(getCurrentMonthFirstDate());
  const urlPrefixBlock = process.env.REACT_APP_URL_BLOCK_PREFIX;
  const [endDate, setEndDate] = useState(getCurrentDate());
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [crewData, setCrewData] = useState(null);
  const [allCrewData, setAllCrewData] = useState(null);
  const fetchCrewDataMonthWise = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${urlPrefixBlock}getcrewDemanded?start=${getFinancialYearStart()}&end=${endDate}`
      );
      if (response.data.status === "ok") {
        setAllCrewData(response.data.daterange.data);
      }
    } catch (err) {
      console.error("Failed to fetch machine types:", err);
      setError(true);
    } finally {
      setLoading(false);
    }
  };
  const fetchCrewData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${urlPrefixBlock}getcrewDemanded?start=${startDate}&end=${endDate}`
      );
      if (response.data.status === "ok") {
        setCrewData(response.data.daterange.data);
      }
    } catch (err) {
      console.error("Failed to fetch machine types:", err);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCrewDataMonthWise();
    fetchCrewData();
  }, []);
  return (
    <div>
      <div className="d-flex justify-content-between bg-dark text-white p-1 papaDiv">
        <h5 className=""> Crew Demand Position </h5>
        <div>
          <div className="d-flex  align-items-center ">
            <b>From </b>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="me-1"
            />

            <b>To </b>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
            <button
              className="ms-1 btn btn-sm btn-outline-light"
              onClick={fetchCrewData}
            >
              Fetch
            </button>
          </div>
        </div>
      </div>
      {loading && <Loading />}
      {crewData && <MonthWisePosition data={allCrewData} />}
      <hr />
      {crewData && <DayWisePosition crewData={crewData} />}
    </div>
  );
};
export default CrewDemandPosition;
